import React, {useState} from 'react'
import IconButton from '@material-ui/core/IconButton'
import HelpIcon from '@material-ui/icons/HelpOutline'
import Tooltip from '@material-ui/core/Tooltip'

const ISSUES_REPORT_TEXT = "Reportar un incidente"
const TUTORIAL_TEXT = "Ver tutoriales"
const ISSUES_LINK = "https://grupotagle.atlassian.net/servicedesk/customer/portals"
const TUTORIAL_LINK = "https://grupotagle.atlassian.net/servicedesk/customer/user/requests?page=1&reporter=org-15&status=open&statuses=open"
const TOOLTIP_TEXT = "Soporte y ayuda"

export default function HelpMenu() {
  const [viewOptions, setViewOptions] = useState(false)
  
  const onClickHelp = () => setViewOptions(!viewOptions)
  const onFocusLoss = () => setViewOptions(false)
  const redirectIssues = () => window.open(ISSUES_LINK)
  const redirectTutorial = () => window.open(TUTORIAL_LINK)

    return (
      <div className="home-help-menu" onBlur={onFocusLoss}>
        <Tooltip title={TOOLTIP_TEXT} placement="bottom" arrow>
          <IconButton onClick={onClickHelp} onBlur={onFocusLoss}>
            <HelpIcon/>
          </IconButton>
        </Tooltip> 
        { viewOptions &&
          <div className="help-options-container">
            <label onMouseDown={redirectIssues}>{ISSUES_REPORT_TEXT}</label>
            <label onMouseDown={redirectTutorial}>{TUTORIAL_TEXT}</label>
          </div>
        }
      </div>
    )
}